<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}" class="container">
    <div v-for="version in versions" :key="version.id" v-bem:item>
      <div class="row equal-height" v-bem:box>
        <div class="col-4">
          <div class="content" v-bem:name>
            <p :class="['badge', {'badge--available': !version.stock_epuise}, {'badge--out-of-stock': version.stock_epuise}]"
            >{{!version.stock_epuise ? $t('steps.version.available') : $t('steps.version.unavailable')}}</p>
            <p class="name">
              <!-- {{model.nom}} -->
              <span>{{version.nom_complet}}</span>
              <span>{{version.motorisation}}</span>
            </p>
          </div>
        </div>
        <div class="col-4" v-bem:image>
          <img :src="version.version_image" :alt="version.nom_complet">
        </div>
        <div :class="['col-4', {out: version.stock_epuise && showPrices}]" v-bem:price-wrapper>
          <div v-bem:price>
            {{$t('currency.starting')}}
            <p class="discount" v-if="showPrices">{{priceFormat(version.prix_web)}}<sub> DHS TTC</sub></p>
            <!-- <p :class="{crossed: showPrices}" v-if="version.prix_web !== version.prix"><span v-if="showPrices">{{$t('steps.version.instead-of')}}</span><span class="prix">{{priceFormat(version.prix)}}<sub> DHS TTC</sub></span></p> -->
          </div>
          <div v-if="!showPrices">
            <p><strong>{{$t('steps.version.countdown')}}</strong></p>
            <p><span>0{{minutes}} : {{seconds}}</span></p>
          </div>
          <div v-if="!showPrices">
            <button
              v-bem:shwoPrice="{animate: !showPrices}"
              class="button button--green"
              @click="$emit('show-form')"
            ><span class="button__text">{{$t('cta.showPrice')}}</span></button>
          </div>
          <button
            v-if="showPrices && !version.stock_epuise"
            class="button button--primary"
            @click="selectVersion(version)"
          ><span class="button__text">{{$t('cta.select')}}</span></button>
        </div>
      </div>
      <div v-bem:equipments v-if="equipements(version).length">
        <p v-bem:equipments:title>{{$t('steps.equipment.label')}}</p>
        <slick v-bem:equipments:carousel="{rtl: $i18n.locale === 'ar'}" :options="carouselOptions">
          <div v-bem:equipments:carousel:item v-for="(equipment, index) in equipements(version)" :key="'item_'+index" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
            <img :src="`https://succursalesrenault.ma/onlinestore/${equipment.image}` || require('@/assets/img/placeholder.jpg')" :alt="equipment.title">
            <p>{{equipment.title}}</p>
          </div>
        </slick>
      </div>
    </div>
    <p>{{$t('notices.images')}}</p>
    <p>{{$t('notices.price')}}</p>
    <div v-bem:popin v-if="showPopin">
      <div v-bem:popin-content>
        <span v-bem:popin-close @click="showPopin = false">&times;</span>
        <p v-bem:popin-title>{{$t(`steps.version.popin-title`)}}</p>
        <div v-bem:popin-car>
          <p>{{$t(`steps.version.popin-text`)}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus'
import Slick from 'vue-slick'
import { mapGetters } from 'vuex'

export default {
  name: 'Versions',
  components: {
    Slick
  },
  data: () => ({
    showPrices: true,
    minutes   : 4,
    seconds   : '59',
    showPopin: false,
    carouselOptions: {
      prevArrow   : '<button type="button" class="slick-prev">&#10094;</button>',
      nextArrow   : '<button type="button" class="slick-next">&#10095;</button>',
      slidesToShow: 4,
      responsive  : [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 425,
          settings: {
            slidesToShow: 1,
            adaptiveHeight: true
          }
        }
      ]
    }
  }),
  methods: {
    selectVersion(version) {
      this.$store.dispatch('setVersion', version);
      this.$router.replace(`/${this.$i18n.locale}/commande/${this.model.nom_lien.toLowerCase()}/${version.nom_version}`);
      this.$emit('next-step');
    },
    countDownTimer() {
      if(this.minutes >= 0) {
        if (this.seconds === '00' && this.minutes > 0) {
          this.seconds = 59;
          this.minutes -= 1;
        }
        let s = parseInt(this.seconds);
        if(s > 0) {
          setTimeout(() => {
            s -= 1;
            s = s < 10 ? '0' + s : s;
            this.seconds = s;
            this.countDownTimer();
          }, 1000);
        }
      }
    },
    equipements(version) {
      const list = version.equippements
      return list && list.length ? version.equippements.filter(({image}) => image && image.includes('.jpg')) : []
    }
  },
  computed: {
		...mapGetters([
      'model',
      'visitedModels'
    ]),
    versions() {
      return this.model.voitures.sort((a, b) => a.prix_web - b.prix_web)
    }
  },
  mounted() {
    EventBus.$on('form-submited', () => this.showPrices = true)
  },
  created() {
    // let storeUser = localStorage.getItem('storeUser')
    // storeUser = storeUser ? JSON.parse(storeUser) : { id: '' }
    // this.showPrices = storeUser.id !== ''
    // this.countDownTimer()
    this.showPopin = !this.visitedModels.includes(this.model.id_simulateur_modele)
    if (!this.visitedModels.includes(this.model.id_simulateur_modele)) {
      this.$store.dispatch('setVisitedModels', this.model.id_simulateur_modele)
    }
  }
}
</script>

<style scoped lang="scss">
.versions {
  max-width: rem(1000);
  margin: 0 auto;
  &__item {
    margin: rem(60) auto;
    &:not(:last-of-type) {
      border-bottom: rem(1) solid $dark-gray;
      padding-bottom: rem(60);
    }
  }
  &__box {
    border: rem(1) solid darken($gray, 20%);
  }
  &__name {
    position: relative;
    text-align: center;
    color: $white;
    background-color: rgba(var(--primary-color), 1);
    min-height: rem(200);
    text-transform: uppercase;
    .name {
      @extend %transform-center;
      width: 100%;
      padding: 0 rem(8);
      @include font-size(32);
      text-transform: uppercase;
      font-weight: bold;
      span {
        display: block;
        // text-transform: initial;
        font-family: var(--primary-font-light);
        font-weight: 300;
        @include font-size(18);
      }
    }
  }
  &__image {
    img {
      max-width: rem(300);
      margin: 0 auto;
    }
  }
  &__price {
    text-transform: uppercase;
    @include font-size(18);
    &-wrapper {
      text-align: center;
      padding: rem(14) rem(8) 0;
      padding-top: rem(48);
      .button {
        margin: rem(8) auto;
      }
      &.out {
        padding-top: rem(48);
        padding-top: rem(72);
      }
    }
    p {
      font-family: var(--primary-font-bold);
      color: rgba(var(--primary-color), 1);
      @include font-size(28);
      sub {
        vertical-align: initial;
        @include font-size(22);
      }
      &.crossed {
        font-family: var(--primary-font);
        position: relative;
        @include font-size(18);
        color: $main-color;
        .prix {
          display: block;
          text-decoration: line-through;
          color: #FF3232;
        }
        sub {
          @include font-size;
        }
      }
      &.discount {
        margin-top: 0;
      }
    }
  }
  &__equipments {
    &-title {
      text-transform: uppercase;
      text-align: center;
      font-weight: bold;
      @include font-size(20);
      margin: rem(24) auto;
    }
    &-carousel {
      &-item {
        padding: 0 rem(8);
        p {
          margin-top: rem(4);
        }
      }
    }
  }
  // &__shwo-price {
  //   &--animate {
  //     animation-name: heartBeat;
  //     animation-duration: 4s;
  //     animation-timing-function: ease-in-out;
  //     animation-iteration-count: infinite;
  //   }
  // }
  &__popin {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999999999;
    background-color: rgba($black, 0.7);
    &-content {
      @extend %transform-center;
      top: 45%;
      background-color: $white;
      width: 95%;
      max-width: rem(520);
      padding: rem(30) rem(4);
    }
    &-close {
      position: absolute;
      top: rem(4);
      right: rem(12);
      @include font-size(22);
      font-weight: bold;
      cursor: pointer;
    }
    &-title {
      text-align: center;
      font-weight: bold;
      text-transform: uppercase;
      @include font-size(20);
      margin-bottom: rem(16);
      color: rgba(var(--primary-color), 1);
      font-family: var(--primary-font-bold);
      span {
        display: block;
        color: $dark-gray;
        @include font-size(14);
        font-weight: normal;
        font-family: var(--primary-font);
        text-transform: initial;
        margin: rem(4) auto rem(16);
      }
    }
    &-car {
      text-align: center;
      @include font-size();
    }
  }
  &--rtl {
    .versions__price {
      direction: ltr;
    }
  }
  @include breakpoint('charmander') {
    &__item {
      margin: rem(30) auto;
      &:not(:last-of-type) {
        padding-bottom: rem(30);
      }
    }
    &__name {
      min-height: initial;
      .name {
        position: initial;
        transform: none;
        padding: rem(16) rem(8);
      }
    }
    &__price {
      &-wrapper {
        padding: 0 rem(8) rem(8);
        &.out {
          padding: 0 rem(8) rem(16);
        }
      }
    }
  }
}
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  7% {
    transform: scale(1.2);
  }
  14% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  35% {
    transform: scale(1);
  }
}
</style>